import React, { useEffect } from 'react'
import LoginProjectCreate from './CreateModal'
import { useState } from 'react'
import { Button, Grid } from '@mui/material'
import { SelectX } from '../../project-portal/form/SelectX'
import { useForm } from 'react-hook-form'
import { LoadingButton } from '@mui/lab'
import { Employee } from '../../api/Endpoints/Employee'
import { ProjectIdContext } from '../../contexts/Project/Project'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/use-auth'
import { Project } from '../../api/Endpoints/Project'

function ChooseProject() {
    const { register, handleSubmit, watch, formState: { errors }, control, setValue, getValues, reset } = useForm();
    const [editId, setEditId] = useState()
    const [formButtonStatus, setFormButtonStatus] = useState({
        label: 'Continue',
        loading: false,
        disabled: false,
    });

    const navigate = useNavigate()
    const auth = useAuth();
    const { ProjectID, setProjectID,setProjectName } = ProjectIdContext()

    const logoutHandler = () => {
        auth.logout();
        setProjectID()
        setProjectName()
        localStorage.clear()
    };

    const onSubmit = () => {
        setFormButtonStatus({
            ...formButtonStatus,
            loading: true,
            disabled: true,
        });

        setProjectID(watch('projects_id')?.id)
        setProjectName(watch('projects_id')?.name)
        localStorage.setItem('projectID',watch('projects_id')?.id)
        localStorage.setItem('projectName',watch('projects_id')?.name)
        navigate('/dashboard')

        setTimeout(() => {
            // Reset loading status (remove this in your actual logic)
            setFormButtonStatus({
                ...formButtonStatus,
                loading: false,
                disabled: false,
            });
        }, 1500);
    }

    const fetchProject = (e) => {
        return Project.get({ keyword: e }).then((response) => {
            if (typeof response.data.data.data !== "undefined") {
                return response.data.data.data
            } else {
                return []
            }
        })
    }

    useEffect(() => {

        if (!watch('projects_id')) {
            setFormButtonStatus({
                ...formButtonStatus,
                loading: false,
                disabled: true,
            });
        } else {
            setFormButtonStatus({
                ...formButtonStatus,
                loading: false,
                disabled: false,
            });
        }

    }, [watch('projects_id')])


    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 'auto', minHeight: '100vh', backgroundColor: '#e9faff' }}>
            <Grid display={'flex'} flexDirection={'column'} alignItems={'center'} sx={{ backgroundColor: 'white', borderRadius: 1, boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)' }} width={500} height={500}>
                <h3 style={{ marginTop: 100 }}>Please Choose a Project To Continue</h3>
                <Grid mt={4} width={300}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <SelectX
                            required={true}
                            placeholder={'Select Project'}
                            // label={"Choose project"}
                            options={fetchProject}
                            control={control}
                            error={errors?.projects_id?.id ? errors?.projects_id?.id?.message : false}
                            error2={errors?.projects_id?.message ? errors?.projects_id?.message : false}
                            name={'projects_id'}
                            defaultValue={watch('projects_id')}
                        />
                    </form>
                </Grid>
                <h5>Or</h5>
                <LoginProjectCreate editId={editId} setEditId={setEditId} />
                <Grid mb={3} width={'90%'} mt={'auto'} display={'flex'} alignItems={'end'} justifyContent={'end'}>
                    <LoadingButton
                        onClick={onSubmit}
                        loading={formButtonStatus.loading}
                        disabled={formButtonStatus.disabled}
                        variant="outlined"
                        type="submit"
                    >
                        {formButtonStatus.label}
                    </LoadingButton>
                </Grid>

            </Grid>
            <div className="logout">
                <Button onClick={logoutHandler}>Logout</Button>
            </div>
        </div>
    )
}

export default ChooseProject
